import { gql } from '@apollo/client';

export const UPSERT_CASE = gql`
  mutation upsertCase($input: UpsertCaseInput!) {
    case: upsertCase(input: $input) {
      id
      appointments {
        id
        clientTempId
      }
    }
  }
`;
